/* eslint-disable no-underscore-dangle */
import { Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { GroupDelegate, Relationship } from '@leverege/molten-core';
export default class ParentRelationshipAttributeValueSuggestor {
  constructor(type, opts = {}) {
    this.attribute = opts.attribute;
    this.delegate = opts.delegate;
    this.relationship = opts.relationship;
    this.objectType = opts.objectType;
  }
  calcParentSourceAndActions() {
    let source = null;
    const srcs = this.attribute?.blueprint?.attribute?.metadata?.setter?.parentSources;
    if (srcs) {
      const src = srcs.find(d => d.path === this.relationship.path);
      if (src && src.sourcePath) {
        const rel = Relationship.getByPath(src.sourcePath);
        if (rel) {
          source = {
            relationship: rel.createResolved(this.delegate.match),
            match: this.delegate.match,
            filter: src.filter,
            queryName: `parentRel-${src.sourcePath}`
          };
        }
      }
    }
    if (source) {
      const labelAttribute = this.attribute?.blueprint?.attribute?.metadata?.setter?.labelAttribute || 'name';
      this._labelAttribute = Attributes.getAttribute(labelAttribute, source.relationship.objectType);
      this._parentActions = new GroupDelegate({
        ...source,
        ttl: 30000
      });
    }
    this._hasCalcedActions = true;
  }
  get labelAttribute() {
    if (!this._labelAttribute && !this._hasCalcedActions) {
      this.calcParentSourceAndActions();
    }
    return this._labelAttribute;
  }
  get parentActions() {
    if (!this._parentActions && !this._hasCalcedActions) {
      this.calcParentSourceAndActions();
    }
    return this._parentActions;
  }
  async suggest(value) {
    if (!this.parentActions || !this.labelAttribute) {
      return [];
    }
    const res = await GlobalState.dispatch(this.parentActions.search({
      filter: {
        type: 'expression',
        value: `*${value}*`,
        field: this.labelAttribute.blueprint.field,
        kind: 'queryString',
        analyzeWildcard: true,
        ignoreCase: true
      },
      sort: [{
        field: this.labelAttribute.blueprint.field,
        missing: '_first',
        order: 'asc'
      }]
    }));
    return res.items.map(item => ({
      name: this.getNameFor(item.id),
      value: item.id
    }));
  }
  getNameFor = value => {
    const state = GlobalState.get();
    const data = state.models.lookup[value];
    if (data) {
      const label = this.labelAttribute.get(data);
      if (label) {
        return label;
      }
    }
    return GlobalState.dispatch(this.parentActions.item(value).get()).then(res => {
      const label = this.labelAttribute.get(res);
      return label || value;
    });
  };
}